import { Observable } from 'rxjs';

export type BoxxGenericState<DATA, SUSCESS, ERROR> = {
  data: DATA;
  isLoading: boolean;
  success: any;
  error: any;
  fetched?: boolean;
};

const genericInitialState = {
  data: null,
  isLoading: false,
  error: null,
  success: null,
  fetched: false,
};

export const getGenericInitialState = () => genericInitialState;

export interface IStoreBase<DATA, SUSCESS, ERROR> {
  // MUST BE IMPLEMENTED AS GETTER (FUNCTIONS)
  readonly data$: Observable<DATA>;
  readonly success$: Observable<SUSCESS>;
  readonly error$: Observable<ERROR>;
  readonly loading$: Observable<boolean>;
  readonly fetched$: Observable<boolean>;
  fetch: (params?: any) => void;
}
